module.exports = __webpack_public_path__ + "img/msc.c0977214.webp";